// URL-based bilingual routing helpers.
// French versions live under /fr — hreflang pairs require distinct URLs.
export const SITE_BASE_URL = "https://quebec-security.com";

// City pages that have a full fr-CA version
export const FR_CITY_SLUGS = ["montreal", "laval", "longueuil", "westmount"];

export const isFrPath = (path) => path === "/fr" || path.startsWith("/fr/");

// French twin of an English path, or null when no FR version exists
export const frTwinFor = (path) => {
  if (path === "/") return "/fr";
  if (path === "/services") return "/fr/services";
  if (path.startsWith("/services/")) return `/fr${path}`;
  if (path === "/seo" || path.startsWith("/seo/")) return `/fr${path}`;
  if (path === "/about" || path === "/contact") return `/fr${path}`;
  if (path.startsWith("/cities/")) {
    const slug = path.split("/")[2];
    return FR_CITY_SLUGS.includes(slug) ? `/fr${path}` : null;
  }
  return null;
};

// English twin of a French path
export const enTwinFor = (path) => (path === "/fr" ? "/" : path.replace(/^\/fr/, "") || "/");

// Localized link target: keep visitors inside /fr when a French version exists
export const localizedPath = (path, lang) =>
  lang === "fr" ? frTwinFor(path) || path : path;

// hreflang link descriptors for a page that has both versions
export const hreflangLinks = (enPath) => {
  const frPath = frTwinFor(enPath);
  if (!frPath) return null;
  return [
    { rel: "alternate", hrefLang: "en-CA", href: `${SITE_BASE_URL}${enPath}` },
    { rel: "alternate", hrefLang: "fr-CA", href: `${SITE_BASE_URL}${frPath}` },
    { rel: "alternate", hrefLang: "x-default", href: `${SITE_BASE_URL}${enPath}` },
  ];
};
